class o extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
export {
  o as LockedError
};
